import React from 'react';
import {
  usePostTableDataTSMutation,
} from 'Services/api/reportsApi';
import { Timeseries } from 'Shared/TimeseriesTables/Timeseries';
import { REPORT_DATA_TABLE_TYPE } from 'Shared/TimeseriesTables/Timeseries.Utils';
import { ReportContext } from './Report.Context';

function TableWrapperDefault() {
  const { posts, columns, calcModuleParams, isFixedSettings, date, pageSize } = React.useContext(ReportContext);

  const useGetDataQuery = () => usePostTableDataTSMutation();

  return (
    <Timeseries
      addByDatasourceTypePartition={false}
      tableType={REPORT_DATA_TABLE_TYPE}
      useGetDataQuery={useGetDataQuery}
      columns={columns}
      posts={posts}
      reportOptions={{
        calcModuleParams,
        isFixedPanelParams: isFixedSettings,
        date,
        pageSize,
      }}
    />
  );
}

export const TableWrapper = React.memo(TableWrapperDefault);
TableWrapper.displayName = 'TableWrapper';
